<div class="max-w-[90vw] min-w-[60vw]">
        
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
        <div class="text-lg font-medium">{{workOrder ? 'Work Order -' : 'New Work Order'}} {{workOrder?.workOrderRef}}</div>
        <button
            mat-icon-button
            (click)="close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>
    
    <form *ngIf="form" [formGroup]="form" class="mt-12 max-h-[calc(100vh-240px)] overflow-y-scroll px-1">
        <div class="grid" [class.md:grid-cols-5]="workOrder">

            <!-- Left Content -->
            <div *ngIf="workOrder" class="flex flex-col gap-6 md:col-span-3 md:border-r md:pr-6 md:mr-6 mb-6 md:mb-0 min-w-[40vw]">
                <div class="flex gap-12">
                    <div class="mb-2">Product</div>
                    <div>
                        <div class="text-lg">{{lookupProductById(workOrder.productId)?.partNumber}}<!-- (x{{workOrder.quantity}})--></div>
                        <div class="text-md">{{lookupProductById(workOrder.productId)?.description}}</div>
                    </div>
                </div>

                <div class="flex gap-9">
                    <div class="">Customer</div>
                    <div class="text-lg">{{workOrder.customer}}</div>
                </div>

                <div *ngIf="manufactureProcesses" class="flex gap-3 items-center"> <!--&& hasReachedGauging()-->
                    <div>Product Type</div>
                    <mat-form-field class="flex-auto fuse-mat-dense" [subscriptSizing]="'dynamic'">
                        <mat-select [formControlName]="'manufactureColumnDefinitionId'" (selectionChange)="loadChosenManufactureProcess($event?.value)">
                            <ng-container *ngFor="let cat of manufactureProcesses">
                                <div class="p-4 pb-2 text-md"><strong>{{cat.name}}</strong></div>

                                <ng-container *ngFor="let process of cat.processes">
                                    <ng-container *ngFor="let col of process.columnDefinitions">
                                        <mat-option class="text-md pl-6" [value]="col.manufactureProcessColumnDefinitionId">
                                            {{process.name}} - {{col.name}}
                                        </mat-option>
                                    </ng-container>
                                </ng-container>

                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>

                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Notes</mat-label>
                    <textarea
                        matInput
                        [formControlName]="'comments'"
                        [rows]="2"
                        cdkTextareaAutosize
                        [cdkAutosizeMinRows]="2"></textarea>
                </mat-form-field>
                
                <!-- Required Components (BOM) -->
                <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                    <div class="text-lg">Required Components (BOM)</div>

                    <div class="flex flex-col divide-y -mt-1 -mb-3">
                        <ng-container *ngFor="let item of bom?.items">
                            <div class="grid grid-cols-6 gap-3 sm:gap-6 py-3">
                                <div class="col-span-4" [class.col-span-6]="!hasReachedGoodsIn()">
                                    <div class="flex gap-4 items-center">
                                        <span>{{lookupPartById(item.partId)?.number ?? '-'}}</span>
                                        <div [class]="getComponentStatusClasses(getComponentInfoForBomItem(item)?.status)">
                                            {{getComponentStatusName(getComponentInfoForBomItem(item)?.status)}}
                                        </div>
                                    </div>
                                    <div class="text-sm line-clamp-2">{{lookupPartById(item.partId)?.description ?? ''}}</div>
                                    <div class="text-md">
                                        <span>Qty: {{getBomItemRequiredAmount(item)}} | In Stock: </span>
                                        <span [class]="getPartCurrentStock(item.partId) >= getBomItemRequiredAmount(item) ? 'text-green-600' : 'text-red-600'">{{getPartCurrentStock(item.partId)}}</span>
                                        <span *ngIf="getPartCurrentStock(item.partId) < getBomItemRequiredAmount(item)" class="text-red-600"> (Short: {{getBomItemRequiredAmount(item) - getPartCurrentStock(item.partId)}})</span>
                                    </div>
                                </div>
                                <div *ngIf="hasReachedGoodsIn()" class="col-span-2 text-sm flex flex-col items-end justify-center">
                                    <div class="flex flex-col w-[120px]">
                                        <div *ngIf="isComponentReceived(item)">Received: {{getComponentInfoForBomItem(item)?.receivedDate | date:'dd/MM/yy'}}</div>
                                        <div *ngIf="isComponentInspected(item)">
                                            <div>Inspected: {{getComponentInfoForBomItem(item)?.inspectionDate | date:'dd/MM/yy'}}</div>
                                            <div>By: {{GetUserName(getComponentInfoForBomItem(item)?.inspectedByUserId)}}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="!isComponentReceived(item)">
                                        <button mat-flat-button color="primary" (click)="markComponentReceived(item)">Receive</button>
                                    </div>
                                    <div *ngIf="isComponentReceived(item) && !isComponentInspected(item)" class="mt-3">
                                        <button mat-flat-button color="primary" (click)="inspectComponent(item)">Start Inspection</button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Supplier and Purchase Order setup button -->
                    <div *ngIf="workOrderId" class="col-span-2 flex gap-4 items-end border-t pt-3">
                        <!-- <mat-form-field class="fuse-mat-dense flex-auto" [subscriptSizing]="'dynamic'">
                            <mat-label>Supplier</mat-label>
                            <mat-select [formControlName]="'supplierId'">
                                <ng-container *ngFor="let supplier of suppliers">
                                    <mat-option [value]="supplier.supplierId">
                                        {{supplier?.name}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field> -->
                        <button [disabled]="!bom" mat-flat-button color="primary" (click)="createWorkOrderPurchaseOrders()">Create Purchase Orders</button>
                    </div>
                </div>

                <!-- Assembly Processes (BOM) -->
                <div *ngIf="!hasReachedGauging()" class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                    <div class="text-lg">Manufacturing Operations (BOM)</div>

                    <ng-container *ngIf="!bom?.assemblyProcesses?.length">No Assembly Process found</ng-container>

                    <div class="flex flex-col divide-y -mt-1 -mb-3">
                        <ng-container *ngFor="let line of bom?.assemblyProcesses">
                            <div class="grid grid-cols-10 py-3">
                                <div>
                                    {{line.sequence}}
                                </div>
                                <div class="col-span-6 flex flex-col gap-1">
                                    <div>{{line.operationCode}}</div>
                                    <div class="text-md">{{line.operationName}}</div>
                                </div>
                                <div class="col-span-3 text-right">
                                    <div class="text-md">Setup: {{line.setupHours * 60 * (line.isSubcontracted ? 35 : 1) | number:'1.0-1'}}m</div>
                                    <div class="text-md">Run: {{line.runPerUnitHours * 60 | number:'1.0-1'}}m</div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Assembly Process (Gauging) -->
                <div *ngIf="hasReachedGauging()" class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                    <div class="text-lg">Manufacturing Operations (Manufacture Process)</div>

                    <ng-container *ngIf="!process">No Manufacture Process selected</ng-container>

                    <div *ngIf="process" class="pb-4 border-b">
                        <div>{{process.name}}</div>
                        <div class="text-sm">{{process.description}}</div>
                    </div>

                    <div class="flex flex-col divide-y -mt-1 -mb-3">
                        <ng-container *ngFor="let stage of process?.stages">
                            <div *ngIf="process.hasStages" class="py-3 -mx-2 px-2 flex gap-4 items-center" [class.bg-yellow-100]="stage.manufactureProcessStageId == selectedStageId">
                                <span>{{stage.name}}</span>
                                <span class="text-md">{{stage.steps.length}} step{{stage.steps.length == 1 ? '' : 's'}}</span>
                                <div class="text-md px-2 py-1 bg-gray-50 rounded-md">Planned: {{getMinutesText(getStageTotal(stage), 0)}}</div>
                            </div>

                            <ng-container *ngFor="let step of stage.steps; let i = index">
                                <div class="grid grid-cols-10 py-3 -mx-2 px-2" [class.bg-yellow-100]="step.manufactureProcessStepId == selectedStageId">
                                    <div>
                                        {{i+1}}
                                    </div>
                                    <div class="col-span-6 flex gap-3 items-center">
                                        <div>{{step.name}}</div>
                                        <div *ngIf="step.isHighlighted" class="text-sm uppercase bg-yellow-100 text-yellow-600 px-2 py-1">Dwell</div>
                                    </div>
                                    <div class="col-span-3 text-right">
                                        <div class="text-md">{{getMinutesText(step.value, 2)}}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>


                <!-- Schedule Information -->
                <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                    <div class="text-lg">Schedule Information</div>

                    <div class="grid grid-cols-2 gap-4">
                        <div class="flex flex-col gap-1">
                            <div class="uppercase text-md tracking-tight">Month / Week</div>
                            <div class="text-md">{{workOrder.startDate | date:'MMM'}} / Wk {{workOrder.startDate | date:'w'}}</div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <div class="uppercase text-md tracking-tight">Hours / Days</div>
                            <div class="text-md">{{workOrder.hoursRequired}} / {{workOrder.daysRequired}}</div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <div class="uppercase text-md tracking-tight">Start Required</div>
                            <div class="text-md">{{workOrder.startDate | date:'dd/MM/yy'}}</div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <div class="uppercase text-md tracking-tight">Planned Finish</div>
                            <div class="text-md">{{workOrder.dueDate | date:'dd/MM/yy'}}</div>
                        </div>
                    </div>
                </div>

                <!-- Time Logging History -->
                <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                    <div class="text-lg">Time Tracking History</div>

                    <div class="flex flex-col divide-y -mt-1">
                        <ng-container *ngFor="let phase of workOrder.stageInfos">
                            <div *ngIf="phase.timerSeconds" class="grid grid-cols-7 py-3 items-center gap-2">
                                <div class="col-span-3">
                                    <span>{{getSwimlaneNameForStage(phase)}} • </span>
                                    <span class="text-md">{{GetUserName(phase.assignedUserId)}}</span>
                                </div>
                                <div class="col-span-2">Logged:</div>
                                <div class="">{{getSecondsText(phase.timerSeconds)}}</div>
                                <div class="text-md">{{phase.timeLoggedDate | date:'dd/MM/yy'}}</div>

                                <ng-container *ngFor="let stage of getStagesForPhase(phase)">
                                    <div class="col-span-3 pl-3 text-md">
                                        <span>{{getStageName(stage)}} • </span>
                                        <span class="text-md">{{GetUserName(stage.loggedUserId)}}</span>
                                    </div>
                                    <div class="col-span-4 text-md grid grid-cols-4 gap-x-2">
                                        <div class="col-span-2">Planned:</div>
                                        <div>{{getMinutesText(getExpectedStageValue(stage.processStageId), 0)}}</div>
                                        <div class="text-md"></div>

                                        <div class="col-span-2">Actual:</div>
                                        <div class="">{{getSecondsText(stage.timerSeconds)}}</div>
                                        <div class="text-md">{{stage.timeLoggedDate | date:'dd/MM/yy'}}</div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        
                        <div class="pt-4 text-right">Total time logged: {{getTotalTimeLogged()}}</div>
                    </div>
                </div>

                <!-- Comments -->
                <mat-accordion *ngIf="workOrder" class="w-full">
                    <mat-expansion-panel class="border rounded-2xl bg-[#f8f8f8] shadow-none">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex gap-2 items-center">
                                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'" color="primary" class="icon-size-5"></mat-icon>
                                <span class="text-lg">Comments</span>
                                <span class="text-sm text-gray-400 ml-1">({{workOrder.workOrderComments?.length || 0}})</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <!-- Add comment -->
                        <div class="flex gap-2 mb-3">
                            <input
                                #commentInput
                                class="bg-white border rounded-md px-3 py-2 text-sm w-full outline-none focus:border-primary"
                                placeholder="Add a comment..."
                                (keydown.enter)="addComment(commentInput.value); commentInput.value = ''">
                            <button mat-flat-button color="primary" class="text-sm"
                                (click)="addComment(commentInput.value); commentInput.value = ''">
                                Post
                            </button>
                        </div>

                        <!-- Comment list -->
                        <div class="flex flex-col divide-y">
                            <ng-container *ngFor="let comment of workOrder.workOrderComments">
                                <div class="py-3">
                                    <div class="flex justify-between items-center">
                                        <div class="font-medium text-sm">{{GetUserName(comment.userId)}}</div>
                                        <div class="text-sm" style="color: #64748b;">{{ comment.timeStamp | date:'d MMM yyyy, h:mm a' }}</div>
                                    </div>
                                    <div class="text-sm mt-1 whitespace-pre-line">{{comment.text}}</div>
                                </div>
                            </ng-container>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <!-- Activity Log -->
                <mat-accordion *ngIf="workOrder?.history?.length" class="w-full">
                    <mat-expansion-panel class="border rounded-2xl bg-[#f8f8f8] shadow-none">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex gap-2 items-center">
                                <mat-icon [svgIcon]="'mat_outline:restore'" color="primary" class="icon-size-5"></mat-icon>
                                <span class="text-lg">Activity Log</span>
                                <span class="text-sm text-gray-400 ml-1">({{workOrder.history.length}})</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="flex flex-col divide-y -mt-1">
                            <ng-container *ngFor="let history of workOrder.history">
                                <div class="py-3">
                                    <div class="italic whitespace-pre-line" [innerHTML]="history.description"></div>
                                    <div class="text-sm mt-1" style="color: #64748b;">
                                        {{ history.timeStamp | date:'d MMM yyyy, h:mm a' }}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                 
                <!-- Files (Product Drawings) -->
                <ng-container *ngIf="workOrder?.productId">
                    <div class="col-span-3 flex flex-col gap-y-2 w-full mt-4">
                        <div class="text-lg">Product Drawings</div>

                        <div class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden" style="height:130px;">
                            <!-- Upload file -->
                            <div>
                                <button mat-icon-button (click)="openFileUpload()">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:paper-clip'"></mat-icon>
                                </button>
                            </div>

                            <!-- Files -->
                            <ng-container *ngIf="files?.length > 0">
                                <div class="file-container p-2 mx-1" *ngFor="let file of files">
                                    <!-- Icons -->
                                    <div class="relative cursor-pointer text-center" (click)="download(file)">
                                        <div class="inline-block relative text-center">
                                            <mat-icon
                                                class="icon-size-14 text-hint opacity-50"
                                                [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                            <div
                                                class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                [class.bg-red-600]="file.type == '.pdf'"
                                                [class.bg-blue-600]="file.type == '.doc'"
                                                [class.bg-green-600]="file.type == '.xls'"
                                                [class.bg-gray-600]="file.type == '.txt'"
                                                [class.bg-amber-600]="file.type == '.jpg'"
                                                [class.bg-yellow-500]="file.type == '.png'">
                                                {{file.type.toUpperCase()}}
                                            </div>
                                            <button *ngIf="!isBasic" class="absolute" (click)="deleteFile(file, $event)">
                                                <mat-icon class="icon-size-2 text-red-600">close</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="file-name cursor-pointer text-s text-center mt-1 line-clamp-2" (click)="download(file)">{{file.name}}</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Right Content -->
            <div class="grid gap-6 h-min grid-cols-2" [class.md:col-span-2]="workOrder">

                <!-- Time Tracking -->
                <div *ngIf="workOrder" class="col-span-2 bg-[#f8f8f8] border rounded-xl p-5 flex flex-col gap-4">
                    <div class="flex gap-2 items-center">
                        <mat-icon [svgIcon]="'heroicons_outline:clock'" color="primary"></mat-icon>
                        <div>Time Tracking</div>
                    </div>

                    <ng-container *ngIf="hasReachedGauging() && process">
                        <mat-form-field class="flex-auto fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Current Stage</mat-label>

                            <mat-select [value]="selectedStageId" (selectionChange)="selectCurrentStage($event)">
                                <ng-container *ngIf="process.hasStages">
                                    <div class="py-3 px-4 text-md">Select a stage...</div>
                                    <ng-container *ngFor="let stage of process.stages; let i = index">
                                        <mat-option class="text-md" [value]="stage.manufactureProcessStageId">{{i+1}}. {{stage.name}}</mat-option>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!process.hasStages">
                                    <div class="py-3 px-4 text-md">Select a step...</div>
                                    <ng-container *ngFor="let stage of process.stages">
                                        <ng-container *ngFor="let step of stage.steps; let i = index">
                                            <mat-option class="text-md" [value]="step.manufactureProcessStepId">{{i+1}}. {{step.name}}</mat-option>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>

                        <div *ngIf="selectedStageId" class="flex justify-between gap-4 text-sm py-2 px-3 bg-gray-50 rounded-md">
                            <div>Planned: {{getMinutesText(getExpectedStageValue(selectedStageId), process.hasStages ? 0 : 2)}} </div>
                            <div>Logged: {{getMinutesText(getLoggedStageValue(selectedStageId), process.hasStages ? 0 : 2)}}</div>
                        </div>
                    </ng-container>


                    <div class="text-center">Current Session</div>
                    <div class="text-center text-2xl -mt-2">{{getFormattedSeconds(timerSeconds)}}</div>
                    <button mat-flat-button color="primary" [class.bg-gray-400]="timeOn" (click)="timeOn ? stopTimer() : startTimer()">{{timeOn ? 'Stop' : 'Start'}} Timer</button>
                    <button *ngIf="selectedStageId" mat-flat-button color="primary" class="bg-green-600" (click)="logTimeToProcessStage()">Log Time to Stage</button>
                    <button mat-flat-button color="primary" (click)="proceedToNextPhase()">Proceed to Next Phase</button>
                </div>

                <!-- Fast-Tracked / Delayed label -->
                <div *ngIf="workOrder?.revisedDueDate && workOrder?.dueDate && workOrder.revisedDueDate !== workOrder.dueDate" class="col-span-full flex justify-center">
                    <div *ngIf="workOrder.revisedDueDate < workOrder.dueDate" class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-100 text-green-700 font-medium text-sm">
                        Fast-Tracked — Revised: {{workOrder.revisedDueDate | date:'dd/MM/yy'}}
                    </div>
                    <div *ngIf="workOrder.revisedDueDate > workOrder.dueDate" class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-100 text-red-700 font-medium text-sm">
                        Delayed — Revised: {{workOrder.revisedDueDate | date:'dd/MM/yy'}}
                    </div>
                </div>

                <!-- Fields -->
                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Start Date</mat-label>
                    <input
                        [formControlName]="'startDate'"
                        [matDatepicker]="startDate"
                        matInput>
                    <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Due Date</mat-label>
                    <input
                        [formControlName]="'dueDate'"
                        [matDatepicker]="dueDate"
                        matInput>
                    <mat-datepicker-toggle matIconSuffix [for]="dueDate"></mat-datepicker-toggle>
                    <mat-datepicker #dueDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field *ngIf="workOrder?.workOrderSwimlane == WorkOrderSwimlane.ThirdParty" class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Expected Arrival Date</mat-label>
                    <input
                        [formControlName]="'expectedArrivalDate'"
                        [matDatepicker]="expectedArrivalDate"
                        matInput>
                    <mat-datepicker-toggle matIconSuffix [for]="expectedArrivalDate"></mat-datepicker-toggle>
                    <mat-datepicker #expectedArrivalDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field *ngIf="workOrderId" class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Assigned User (this stage)</mat-label>
                    <mat-select [value]="currentStageAssignedUserId">
                        <ng-container *ngFor="let user of allUsers">
                            <mat-option [value]="user.id">
                                {{user.firstName}} {{user.lastName}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

                <ng-container *ngIf="!workOrderId">
                    <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                        <mat-label>Sales Order</mat-label>
                        <mat-select [formControlName]="'salesOrderId'">
                            <ng-container *ngFor="let salesOrder of salesOrders">
                                <mat-option [value]="salesOrder.purchaseOrderId">
                                    {{salesOrder?.salesOrderRef}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                        <mat-label>Product</mat-label>
                        <mat-select [formControlName]="'productId'" [disabled]="!form.controls['salesOrderId'].value">
                            <mat-select-trigger>{{lookupProductById(form.controls['productId'].value)?.partNumber}}</mat-select-trigger>
                            <ng-container *ngFor="let product of getProductsForSelectedSalesOrder(); trackBy: trackByFn">
                                <mat-option [value]="product.dlmProductId">
                                    <div>{{ product.partNumber }}</div>
                                    <div class="text-sm leading-[1.1] pb-2">{{ product.description }}</div>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </ng-container>

                <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Work Center / Machine</mat-label>
                    <mat-select [formControlName]="'assignedMachineId'">
                        <ng-container *ngFor="let machine of machines">
                            <mat-option [value]="machine.productionResourceId">
                                {{machine.name}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Priority</mat-label>
                    <mat-select [formControlName]="'priority'">
                        <ng-container *ngFor="let priority of salesOrderPriorities">
                            <mat-option [value]="priority.value">
                                {{priority?.name}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                
                <mat-form-field *ngIf="workOrderId" class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Status</mat-label>
                    <mat-select [formControlName]="'status'">
                        <ng-container *ngFor="let status of statuses">
                            <mat-option [value]="status.value">
                                {{status?.name}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                
                <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Quantity</mat-label>
                    <input
                        [formControlName]="'quantity'"
                        type="number"
                        matInput>
                    <span matSuffix class="pl-2">units</span>
                </mat-form-field>

                <!-- Sales order and BOM Links -->
                <ng-container *ngIf="workOrder">
                    <div class="col-span-2 flex flex-col gap-1">
                        <mat-label>Sales Order</mat-label>
                        <div class="bg-white border rounded-lg py-3 px-4 flex gap-4 items-center hover:bg-gray-50 cursor-pointer transition-colors" (click)="openLinkedPo()">
                            <mat-icon class="text-primary" [svgIcon]="'mat_outline:shopping_cart'"></mat-icon>
                            <div>
                                <div>{{workOrder?.salesOrderRef}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-2 flex flex-col gap-1">
                        <mat-label>BOM</mat-label>
                        <div class="bg-white border rounded-lg py-3 px-4 flex gap-4 items-center hover:bg-gray-50 cursor-pointer transition-colors" (click)="openBomDetails()">
                            <mat-icon class="text-primary" [svgIcon]="'heroicons_outline:clipboard-document-list'"></mat-icon>
                            <div>
                                <div>BOM-{{bom?.createdDate | date:'yyyy'}}-{{ bom?.bomId.toString().padStart(3, '0')}} ({{bom?.createdDate | date:'dd/MM/yy'}})</div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                
                <!-- Actual Progress -->
                <ng-container *ngIf="workOrder">
                    <div class="col-span-2 border rounded-2xl p-5 grid sm:grid-cols-2 gap-4 w-full bg-[#f8f8f8]">
                        <div class="sm:col-span-2 text-lg">Actual Progress</div>
                        
                        <div class="flex flex-col gap-1">
                            <div class="uppercase text-md tracking-tight">Actual Start</div>
                            <div class="text-md flex gap-3 items-center">
                                <div>{{workOrder.actualStartDate | date:'dd/MM/yyyy'}}</div>
                                <div *ngIf="workOrder.actualStartDate" class="uppercase text-md px-2 py-1 tracking-tight"
                                    [class.text-green-600]="isOnTime()" [class.text-red-600]="!isOnTime()"
                                    [class.bg-green-50]="isOnTime()" [class.bg-red-50]="!isOnTime()">
                                    {{isOnTime() ? 'On Time' : 'Late'}}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <div class="uppercase text-md tracking-tight">Actual Finish</div>
                            <div class="text-md">{{workOrder.actualFinishDate | date:'dd/MM/yyyy'}}</div>
                        </div>
                        
                        <div class="sm:col-span-2 flex flex-col gap-1">
                            <div>Completion Progress</div>

                            <div class="flex gap-4 items-center">
                                <mat-progress-bar
                                    class="w-full"
                                    mode="determinate"
                                    [ngClass]="getProgressClass()"
                                    [value]="getProgress()">
                                </mat-progress-bar>
                                <div class="text-sm">{{getProgress() | number:'1.0-1'}}%</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="workOrder?.workOrderSwimlane == WorkOrderSwimlane.ReadyForDispatch" class="col-span-2 border rounded-2xl p-5 grid sm:grid-cols-2 gap-4 w-full bg-[#f8f8f8]">
                        <div class="sm:col-span-2 text-lg">Dispatch Product</div>

                        <mat-form-field class="fuse-mat-dense flex-auto" [subscriptSizing]="'dynamic'">
                            <mat-label>Courier</mat-label>
                            <mat-select [formControlName]="'courier'">
                                <ng-container *ngFor="let courier of couriers">
                                    <mat-option [value]="courier">
                                        {{courier}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Tracking Number</mat-label>
                            <input [formControlName]="'trackingNumber'" matInput>
                        </mat-form-field>

                        <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Number of Packages</mat-label>
                            <input [formControlName]="'numberOfPackages'" type="number" min="1" step="1" matInput>
                        </mat-form-field>

                        <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Weight (kg)</mat-label>
                            <input [formControlName]="'weightKg'" type="number" min="0" step="0.1" matInput>
                        </mat-form-field>

                        <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Dispatch Date</mat-label>
                            <input
                                [formControlName]="'dispatchDate'"
                                [matDatepicker]="dispatchDate"
                                matInput>
                            <mat-datepicker-toggle matIconSuffix [for]="dispatchDate"></mat-datepicker-toggle>
                            <mat-datepicker #dispatchDate></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Revised Dispatch Date</mat-label>
                            <input
                                [formControlName]="'revisedDispatchDate'"
                                [matDatepicker]="revisedDispatchDate"
                                matInput>
                            <mat-datepicker-toggle matIconSuffix [for]="revisedDispatchDate"></mat-datepicker-toggle>
                            <mat-datepicker #revisedDispatchDate></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Reason for Date Change</mat-label>
                            <input [formControlName]="'reasonForDateChange'" matInput placeholder="Enter reason for revised date change...">
                        </mat-form-field>
                        
                        <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                            <mat-label>Dispatch Notes</mat-label>
                            <textarea
                                matInput
                                [formControlName]="'dispatchNotes'"
                                placeholder="Any special instructions or notes..."
                                [rows]="2"
                                cdkTextareaAutosize
                                [cdkAutosizeMinRows]="2"></textarea>
                        </mat-form-field>

                        <button mat-flat-button color="primary" class="col-span-2 bg-green-600" (click)="proceedToNextPhase()">Mark as Dispatched</button>
                    </div>
                </ng-container>

                <!-- QR Code -->
                <ng-container *ngIf="workOrder">
                    <div class="col-span-2 flex gap-4 items-end">
                        <div id="qr-print-area" class="qr-border border-solid border-black border-4 p-1 rounded-2xl bg-white">
                            <qrcode
                                [qrdata]="'nexus-work-order-' + workOrderId"
                                [width]="256"
                                [errorCorrectionLevel]="'M'"
                                [elementType]="'svg'"
                                allowEmptyString
                            ></qrcode>
                        </div>
                        <button mat-flat-button color="primary" (click)="printQrCode()">
                            <mat-icon svgIcon="heroicons_outline:printer" class="icon-size-4"></mat-icon>
                            <span class="ml-1">Print Label</span>
                        </button>
                    </div>
                </ng-container>
            </div>

        </div>
    </form>

    <!-- Divider -->
    <div class="my-6 border-t"></div>

    <!-- Actions -->
    <div class="flex flex-row items-between w-full gap-4">
        <div class="flex items-center justify-end ml-auto gap-4">
            <button
                (click)="close()"
                mat-stroked-button
                type="button">
                Cancel
            </button>
            
            <button
                (click)="save()"
                mat-flat-button
                type="button"
                [color]="'primary'"
                [disabled]="!form?.valid">
                <span class="ml-1">Save</span>
            </button>
        </div>
    </div>

</div>



<!-- Print stuff -->
<div id="print-header" style="display: none;">
  <img class="pt-8 px-8" src="assets/dlm-images/dlm/dlm-header.png" />
</div>

<div id="print-footer" style="display: none;">
  <img class="p-8" src="assets/dlm-images/dlm/dlm-footer-grey.png" />
</div>
